import {computed} from "vue";
import {useRoute} from "vue-router";
import _ from "lodash";
import useHelper from "@/composables/useHelper";

const {computeRawStatus} = useHelper();

export default function useFilteredContent(store) {

    const userStat = computed(() => {
        return store.userStat;
    });

    const filteredContent = computed(() => {
        const route = useRoute();
        const query = route.query;
        let content = store.userContent;

        if (!content) {
            return [];
        }

        if (_.size(query) < 1) {
            return content;
        }

        return content.filter((item) => {
            let status = computeRawStatus(item);
            if (_.has(query, status)) {
                return item;
            }
        });
    });

    return {filteredContent, userStat};
}
